var map = {
	"./404.svg": "sEM+",
	"./X.svg": "ggGF",
	"./broadcast.svg": "FUee",
	"./btnHide.svg": "T2FL",
	"./btnShow.svg": "mnPi",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./customize.svg": "WyZs",
	"./dashboard.svg": "BCGP",
	"./device.svg": "k6Cd",
	"./device1.svg": "eHTq",
	"./devicesbtn.svg": "wiNR",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./fold.svg": "5pIo",
	"./form.svg": "sTIr",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./icon_Microsoft.svg": "Fe0l",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./navl-logo.svg": "+ULD",
	"./navl-logo1.svg": "dEGe",
	"./navl-logo2.svg": "gkaV",
	"./nested.svg": "798r",
	"./open.svg": "8ckU",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./resources.svg": "z+Pz",
	"./shoppingCard.svg": "dNDk",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./taskSchedule.svg": "Wto1",
	"./theme.svg": "hdtf",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 35